import React from 'react'
import styled from 'styled-components'

const StyledCard = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    border: 1px solid rgba(0, 0, 0, 0.125);
    border-radius: 0.25rem;
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
`

const CardBody = styled.div`
    flex: 1 1 auto;
    padding: 1.25rem;
`

const CardHeader = styled.div`
    padding: 0.75rem 1.25rem;
    margin-bottom: 0;
    background-color: rgba(0, 0, 0, 0.03);
    border-bottom: 1px solid rgba(0, 0, 0, 0.125);
`

const CardImg = styled.img`
    width: 100%;
    border-top-left-radius: calc(0.25rem - 1px);
    border-top-right-radius: calc(0.25rem - 1px);
`

const CardTitle = styled.h5`
    margin-bottom: 0.75rem;
`

const CardText = styled.p`
    margin-top: 0;
    margin-bottom: 1rem;
`

const Card = ({ children, ...props }) => {
    return <StyledCard {...props}>{children}</StyledCard>
}

Card.Body = CardBody
Card.Header = CardHeader
Card.Img = CardImg
Card.Title = CardTitle
Card.Text = CardText

export default Card
